import React from 'react';

import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';

import { cn } from '@/utils/cn';

const DropdownMenu = DropdownMenuPrimitive.Root;

const DropdownMenuTrigger = React.forwardRef<
  React.ElementRef<typeof DropdownMenuPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.Trigger>
>(({ className, style, children, ...props }, ref) => (
  <DropdownMenuPrimitive.Trigger
    ref={ref}
    className={cn('outline-none cursor-pointer w-fit h-fit p-1', className)}
    {...props}
  >
    {children}
  </DropdownMenuPrimitive.Trigger>
));

const UnstyledDropdownMenuTrigger = React.forwardRef<
  React.ElementRef<typeof DropdownMenuPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.Trigger>
>(({ children, ...props }, ref) => (
  <DropdownMenuPrimitive.Trigger ref={ref} {...props}>
    {children}
  </DropdownMenuPrimitive.Trigger>
));

const DropdownMenuPortal = DropdownMenuPrimitive.Portal;

const DropdownMenuContent = React.forwardRef<
  React.ElementRef<typeof DropdownMenuPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.Content>
>(({ className, style, children, ...props }, ref) => (
  <DropdownMenuPrimitive.Content
    ref={ref}
    style={{
      minWidth: '100px',
      ...style,
    }}
    className={cn(
      'border border-gray-100 outline-none flex w-auto flex-col shadow-md rounded-md bg-white duration-400 ease-[cubic-bezier(0.16, 1, 0.3, 1)] transition-opacity transition-transform',
      className,
    )}
    {...props}
  >
    {children}
  </DropdownMenuPrimitive.Content>
));

const UnstyledDropdownMenuContent = React.forwardRef<
  React.ElementRef<typeof DropdownMenuPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.Content>
>(({ children, ...props }, ref) => (
  <DropdownMenuPrimitive.Content ref={ref} {...props}>
    {children}
  </DropdownMenuPrimitive.Content>
));

const DropdownMenuItem = React.forwardRef<
  React.ElementRef<typeof DropdownMenuPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.Item> & { isDestructive?: boolean }
>(({ className, style, children, isDestructive, ...props }, ref) => (
  <DropdownMenuPrimitive.Item
    ref={ref}
    className={cn(
      'flex outline-none font-normal text-sm leading-5 min-h-[25px] h-auto py-2 px-3 relative cursor-pointer hover:bg-gray-100',
      className,
      isDestructive ? 'text-red-900' : 'text-gray-900',
    )}
    {...props}
  >
    {children}
  </DropdownMenuPrimitive.Item>
));

const UnstyledDropdownMenuItem = React.forwardRef<
  React.ElementRef<typeof DropdownMenuPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.Item> & { isDestructive?: boolean }
>(({ children, ...props }, ref) => (
  <DropdownMenuPrimitive.Item ref={ref} {...props}>
    {children}
  </DropdownMenuPrimitive.Item>
));

export {
  // biome-ignore lint/style/useComponentExportOnlyModules: UI library module export pattern
  DropdownMenu,
  DropdownMenuTrigger,
  UnstyledDropdownMenuTrigger,
  // biome-ignore lint/style/useComponentExportOnlyModules: UI library module export pattern
  DropdownMenuPortal,
  DropdownMenuContent,
  UnstyledDropdownMenuContent,
  DropdownMenuItem,
  UnstyledDropdownMenuItem,
};
